import { Component, OnInit } from '@angular/core';
import { BoardOfTrusteesService } from '../../services/board-of-trustees-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { BoardOfTrustees } from '../../models/board-of-trustees';
import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';
import { uploadService } from '../../../../shared/uploadService';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-add-board-of-trustee',
  templateUrl: './add-board-of-trustee.component.html',
  styleUrls: ['./add-board-of-trustee.component.scss'],
})
export class AddBoardOfTrusteeComponent implements OnInit {
  model: BoardOfTrustees = {} as BoardOfTrustees;
  formData: FormData = new FormData();
  validPhoto = false;
  isEdit = false;
  uploadThumbnail: boolean = false;
  private nextOrderIndex: number ;
  newPhotoUploaded = false;
  isSaving = false;
  constructor(
    private service: BoardOfTrusteesService,
    private diagRef: NbDialogRef<AddBoardOfTrusteeComponent>,
    private toast: NbToastrService,
    private route : Router,
    private uploadService: uploadService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if(this.isEdit){
      this.validPhoto = true;
    }
    else{
      this.uploadThumbnail = true;
      
      this.service.getData('board-Of-trustees').subscribe(
        (res) => {
          const list = (res as any[]) || [];
          let maxOrder = 0;
          list.forEach((item) => {
            const oi = item && typeof item.orderIndex === 'number' ? item.orderIndex : null;
            if (oi && oi > maxOrder) maxOrder = oi;
          });
          this.nextOrderIndex = (maxOrder || 0) + 1;
        },
        (_) => {}
      );
    }

  }

  getFormData(event) {
    if (event) {
      this.formData = event;
      this.validPhoto = true;
      this.newPhotoUploaded = true;
    } else {
      this.formData = new FormData();
      this.validPhoto = false;
      this.newPhotoUploaded = false;
    }
  }

  save(form) {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;
    this.service.uploadFile(this.formData).subscribe((res) => {
      this.model.pic = {} as FileVm;
      this.model.pic.fileName = res.fileName;
      this.model.pic.originalFileName = this.extractOriginalFileNameFromFormData();
      this.model.type = 2;
      if (!this.isEdit) {
        if (this.nextOrderIndex == null) {
          
          this.nextOrderIndex = 1;
        }
        this.model.orderIndex = this.nextOrderIndex as number;
      }
      this.service.post(this.model).subscribe((res) => {
        this.isSaving = false;
        this.diagRef.close('true');
        this.toast.show('تم إضافة عضو جديد بنجاح', '', { status: 'success', duration: 3000 });
      },
      () => {
        this.isSaving = false;
      });
    },
    () => {
      this.isSaving = false;
    });
  }

  close(){
    this.diagRef.close();
  }

  updateBoard() {
    if (this.isSaving) {
      return;
    }

    const upload$ = this.newPhotoUploaded
      ? this.uploadService.uploadImage(this.formData)
      : this.uploadService.uploadImage(this.model.pic);

    this.isSaving = true;

    upload$
      .pipe(
        switchMap((uploadedImage) => {
          if (uploadedImage) {
            this.ensurePic();
            this.model.pic.fileName = uploadedImage.fileName || this.model.pic.fileName;
            this.model.pic.path = uploadedImage.path || this.model.pic.path;
            this.model.pic.type = uploadedImage.type || this.model.pic.type;
            if (uploadedImage.originalFileName) {
              this.model.pic.originalFileName = uploadedImage.originalFileName;
            } else if (this.newPhotoUploaded) {
              this.model.pic.originalFileName = this.extractOriginalFileNameFromFormData();
            }
          }
          this.model.type = 2;
          return this.service.put(this.model.id, this.model);
        })
      )
      .subscribe(
        () => {
          this.isSaving = false;
          this.newPhotoUploaded = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل العضو بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          console.error('Error updating board of trustees member:', error);
          this.isSaving = false;
          this.toast.danger('حدث خطأ أثناء تعديل بيانات العضو', 'رسالة تحذيرية');
        }
      );
  }

  update() {
    this.service.put(this.model.id, this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم تعديل الفاعلية بنجاح', '', { status: 'success', duration: 3000 });
    });
  }

  removePhoot() {
    this.uploadThumbnail = true;
    this.validPhoto = false;
    this.newPhotoUploaded = false;
    this.formData = new FormData();
  }

  private ensurePic() {
    if (!this.model.pic) {
      this.model.pic = {} as FileVm;
    }
  }

  private extractOriginalFileNameFromFormData(): string {
    let originalName = (this.model && this.model.pic && this.model.pic.originalFileName) ? this.model.pic.originalFileName : '';
    if (this.formData && typeof this.formData.forEach === 'function') {
      this.formData.forEach((value: any) => {
        if (value && value.name) {
          originalName = value.name;
        }
      });
    }
    return originalName;
  }
}
